import Head from "next/head";
import StatusMain from "@/components/developers/api/status-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Status() {
  return (
    <>
      <Head>
        <title>{seoData.DEV_API_STATUS.title}</title>
        <SeoMetaData data={seoData.DEV_API_STATUS} />
      </Head>

      <StatusMain />
    </>
  );
}
